/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 18/9/2020
 */

//redirects by preserving params
export default (name, params = {}) => {
	return (route) => ({
		...route,
		name,
		params: {
			...route.params,
			...params
		}
	})
}


